import { Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ProcessingTimeoutAlert() {
  const { t } = useTranslation();
  return (
    <Alert severity='warning'>
      <Typography variant='body2'>{t('selfService.processingTimeout')}</Typography>
    </Alert>
  );
}
